export default __webpack_public_path__ + "img/ejXYawTT.1a7fb6e1.svg";